import CardImg from "../Assets/fried_oyster_mushroom.png";
import Footer from "../Components/Footer/Footer";
import ProductCard from "../Components/ProductCard/ProductCard";
import React from "react";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function FriedOysterMushroom() {
  useMetaTracking("ViewContent", {
    content_name: "Fried Oyster Mushroom",
    content_category: "Vegan Menu",
    content_ids: ["fried_oyster_mushroom"],
    content_type: "vegan_banh_mi",
  });

  return (
    <>
      {/* Page Title */}
      <Helmet>
        <title>Fried Oyster Mushroom | Đông Hưng Viên Bakery</title>
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <ProductCard
          cardImg={CardImg}
          titleHead="Fried Oyster Mushroom"
          titleSubHead="À La Carte: $12 per half-pound | $10.50 per sandwich"
          detailBody="Fresh oyster mushrooms are transformed into vegan fried ‘chicken’ seasoned with aromatic spices, achieving the perfect golden crunch. *Can be served in a classic bánh mì with house-made spicy vegan mayo for the ultimate comfort food experience."
          detailBodyBr="Contains: wheat, mushroom, almond"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu" 
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default FriedOysterMushroom;